var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

export var verifyType = function verifyType(value, type) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== type) {
    var typeError = new Error('Value "' + value + '" is not of type "' + type + '".');

    // preserve original stack trace
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(typeError, verifyType);
    }
    throw typeError;
  }
  return value;
};